import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Box,
  Chip,
} from "@mui/material";
import { useState, useEffect } from "react";
import KsbDialogActions from "../../../components/KsbDialogActions";

export default function UserDialog({ user, onClose, onSave }) {
  const [form, setForm] = useState(user);

  useEffect(() => {
    setForm(user);
  }, [user]);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleRoleToggle = (role) => {
    const currentRoles = form.roles || [];

    const roles = currentRoles.includes(role)
      ? currentRoles.filter((r) => r !== role)
      : [...currentRoles, role];

    setForm({ ...form, roles });
  };

  const handleSubmit = () => {
    if (!form.firstName || !form.lastName) {
      alert("Name darf nicht leer sein");
      return;
    }

    onSave(form);
  };

  const AVAILABLE_ROLES = ["Admin", "Teacher", "Student"];

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>User bearbeiten</DialogTitle>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        {/* ✅ NAME */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="Vorname"
            value={form.firstName || ""}
            onChange={handleChange("firstName")}
            fullWidth
          />

          <TextField
            label="Nachname"
            value={form.lastName || ""}
            onChange={handleChange("lastName")}
            fullWidth
          />
        </Box>

        {/* ✅ ROLES */}
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {AVAILABLE_ROLES.map((role) => (
            <Chip
              key={role}
              label={role}
              clickable
              color={(form.roles || []).includes(role) ? "primary" : "default"}
              onClick={() => handleRoleToggle(role)}
            />
          ))}
        </Box>

        {/* ✅ STATUS */}
        <TextField
          select
          label="Status"
          value={
            form.isActive ? "active" : form.isVerified ? "verified" : "inactive"
          }
          onChange={(e) => {
            const value = e.target.value;

            setForm({
              ...form,
              isActive: value === "active",
              isVerified: value === "active" || value === "verified",
            });
          }}
          SelectProps={{ native: true }}
        >
          <option value="inactive">Nicht aktiv</option>
          <option value="verified">Verifiziert</option>
          <option value="active">Aktiv</option>
        </TextField>

        {/* ✅ Password */}
        <TextField
          label="Neues Passwort"
          type="password"
          value={form.newPassword || ""}
          onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
          fullWidth
          helperText="Leer lassen, um Passwort nicht zu ändern"
        />
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSubmit}
        confirmLabel="Speichern"
        confirmDisabled={!form.firstName || !form.lastName}
        dangerAction={() => console.log("delete user not implemented yet")}
        dangerLabel="Löschen"
      />
    </Dialog>
  );
}
